// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3OopJ","inner":"Form_inner__FJL6R","range":"Form_range__1CweP","name":"Form_name__3LEuY","actions":"Form_actions__32Wi3"};